<template>
  <div class="smart-solid-waste-transportation-management">
    <top-nav :banner="data.banner" isParent></top-nav>
    <pain></pain>
    <feature-grid data-key="smart-solid-waste-transportation-management" section-key="flowTracking" light></feature-grid>
    <comm-scene :dataKey="'smart-solid-waste-transportation-management'"></comm-scene>
    <product-list></product-list>
    <customer-wall></customer-wall>
    <footer-resolution></footer-resolution>
    <my-footer></my-footer>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Pain from './components/pain.vue';
import FeatureGrid from './components/feature-grid.vue';
import CustomerWall from '@/views/index-view/customer-wall.vue';

export default {
  components: {
    Pain,
    FeatureGrid,
    CustomerWall
  },
  computed: {
    ...mapGetters(['globalData']),
    data() {
      return this.globalData['smart-solid-waste-transportation-management'];
    }
  }
};
</script>

<style lang="scss" scoped>
.smart-solid-waste-transportation-management {
  background: #ffffff;

  ::v-deep .banner-item-title {
    text-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);
  }

  ::v-deep .banner-item-brief {
    width: 54%;
    font-size: 22px;
    line-height: 1.8;
    text-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  }
}
</style>
